webpackJsonp([83917863231159],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.RestrictedStateWiseComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _restrictedStates = __webpack_require__(86);
	
	var _restrictedStates2 = _interopRequireDefault(_restrictedStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RestrictedStateWiseComponent = exports.RestrictedStateWiseComponent = function (_React$Component) {
		_inherits(RestrictedStateWiseComponent, _React$Component);
	
		function RestrictedStateWiseComponent() {
			_classCallCheck(this, RestrictedStateWiseComponent);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		RestrictedStateWiseComponent.prototype.render = function render() {
			var _props = this.props,
			    children = _props.children,
			    regionName = _props.regionName;
	
			if (_restrictedStates2.default.indexOf(regionName.toLowerCase()) >= 0) {
				return null;
			} else return children;
		};
	
		return RestrictedStateWiseComponent;
	}(_react2.default.Component);
	
	RestrictedStateWiseComponent.propTypes = {
		children: _propTypes2.default.node,
		regionName: _propTypes2.default.string
	};
	
	exports.default = RestrictedStateWiseComponent;

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var resStates = ["delhi", "uttar pradesh", "haryana", "punjab", "chandigarh", "national capital territory of delhi", "new delhi", "uttarakhand"];
	
	exports.default = resStates;
	module.exports = exports["default"];

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.DetailView = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Heading = __webpack_require__(43);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(635);
	
	var _reactBootstrap = __webpack_require__(55);
	
	var _reactFacebookPixel = __webpack_require__(32);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _reactSlick = __webpack_require__(62);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(169);
	
	__webpack_require__(168);
	
	var _productListConstant = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(78);
	
	var _contentPage = __webpack_require__(19);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(20);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _RestrictedStateWiseComponent = __webpack_require__(85);
	
	var _RestrictedStateWiseComponent2 = _interopRequireDefault(_RestrictedStateWiseComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import CommentSection from "../../../components/CommentSection"
	
	// ReactPixel.track("AddToCart", {})
	var DetailView = exports.DetailView = function (_React$Component) {
	  _inherits(DetailView, _React$Component);
	
	  function DetailView(args) {
	    _classCallCheck(this, DetailView);
	
	    // const { content } = this.props
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.onChangeRecipe = function () {
	      _this.setState({
	        showDropdown: !_this.state.showDropdown
	      });
	    };
	
	    _this.handleQuantity = function (fn) {
	      var qty = _this.state.qty;
	
	      if (fn === "add") {
	        _this.setState({
	          qty: qty + 1,
	          added: false
	        });
	      } else {
	        if (qty - 1 > 0) {
	          _this.setState({
	            qty: qty - 1,
	            added: false
	          });
	        }
	      }
	    };
	
	    _this.addToCart = function () {
	      var _extends2;
	
	      var setToCart = _this.props.setToCart;
	      var _this$state = _this.state,
	          qty = _this$state.qty,
	          content = _this$state.content;
	
	      if (qty <= 0) {
	        return;
	      }
	      // window.localStorage.setItem("cart", {})
	      var cart = JSON.parse(localStorage.getItem("cart"));
	      var addedProduct = _extends({}, content, {
	        qty: qty
	      });
	      if (!cart) {
	        cart = {
	          products: {},
	          totalNumber: 0
	        };
	      }
	      var totalNumber = 1;
	      var bucket = {
	        products: _extends({}, cart.products, (_extends2 = {}, _extends2[addedProduct.id] = addedProduct, _extends2)),
	        totalNumber: totalNumber
	      };
	      _reactFacebookPixel2.default.track("AddToCart", bucket);
	      // Object.keys(cart.products).map((key) => {
	      // 	totalNumber = totalNumber + cart.products[key].qty
	      // })
	      // let bucket = cart ? (cart.products || {}) : {}
	      _this.setState({
	        added: true
	      });
	      // console.log("content", content, cart, bucket)
	      // return
	      localStorage.setItem("cart", JSON.stringify(bucket));
	      setToCart(bucket);
	      // var retrievedObject = localStorage.getItem("cart")
	    };
	
	    _this.state = {
	      showDropdown: false,
	      qty: 0,
	      added: false,
	      content: {}
	    };
	    _this.type = "";
	    return _this;
	  }
	
	  DetailView.prototype.componentWillMount = function componentWillMount() {
	    // console.log("w", window.location)
	  };
	
	  DetailView.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var contentPromise = this.props.contentPromise;
	
	    _reactFacebookPixel2.default.init("145006083100066");
	    contentPromise.then(function (item) {
	      // console.log("item", item)
	      if (!item.productName) {
	        (0, _gatsbyLink.navigateTo)("/store");
	      } else {
	        _this2.setState({
	          qty: item.qty || 0,
	          added: item.qty > 0,
	          content: item
	        });
	      }
	    });
	  };
	
	  DetailView.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    var contentPromise = nextProps.contentPromise;
	
	    if (nextProps.isAddToCartChange !== this.props.isAddToCartChange) {
	      contentPromise.then(function (item) {
	        // console.log("item", item)
	        if (!item.productName) {
	          (0, _gatsbyLink.navigateTo)("/store");
	        } else {
	          _this3.setState({
	            qty: item.qty || 0,
	            added: item.qty > 0,
	            content: item
	          });
	        }
	      });
	    }
	  };
	
	  DetailView.prototype.componentWillUnmout = function componentWillUnmout() {};
	
	  DetailView.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props = this.props,
	        header1 = _props.header1,
	        location = _props.location,
	        region = _props.region;
	    var _state = this.state,
	        showDropdown = _state.showDropdown,
	        qty = _state.qty,
	        added = _state.added,
	        content = _state.content;
	
	    var searchString = (location.search.split("?")[1] || "").split("&");
	    // const type = searchString[0] || null
	    // const title = searchString[1] || null
	    // console.log("header1", title)
	    var settingsForDesktop = {
	      dots: false,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 4,
	      slidesToScroll: 4
	    };
	    var settingsPanel2 = {
	      dots: false,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 3,
	      slidesToScroll: 2
	    };
	    var settings2 = {
	      dots: false,
	      infinite: true,
	      speed: 500,
	      slidesToShow: 1,
	      slidesToScroll: 1
	    };
	    var sliderList = [];
	    var redirectTo = "";
	    if (header1 === "Spices") {
	      sliderList = [].concat(_productListConstant.Misc, _productListConstant.SpiceDetails);
	      redirectTo = "?all_spices";
	    } else if (header1 === "Dhoop") {
	      sliderList = _productListConstant.DhoopDetails;
	      redirectTo = "?puja_materials";
	    } else {
	      sliderList = [].concat(_productListConstant.Misc, _productListConstant.SpiceDetails);
	      redirectTo = "?misc";
	    }
	    // content = {}
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "" + (content.productName || "Bawa Masala Company About Products | Fragrant, Flavourful, Fresh Spices"),
	        image: content.imgUrls,
	        description: content.desc || "Enquire about bulk or dealer orders.",
	        location: location
	      }),
	      content.productName ? _react2.default.createElement(
	        "div",
	        { className: "global__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "product__detail__wrapper" },
	          _react2.default.createElement(_Heading2.default, { title: header1 }),
	          _react2.default.createElement(
	            "div",
	            { className: "item__content" },
	            _react2.default.createElement(
	              "div",
	              { className: "nav__bar" },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/products" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "active" },
	                  "Product Range"
	                )
	              ),
	              "/",
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/store" + redirectTo },
	                _react2.default.createElement(
	                  "span",
	                  { className: "active" },
	                  header1
	                )
	              ),
	              "/",
	              _react2.default.createElement(
	                "span",
	                { className: "item__name" },
	                content.productName
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "item__wrapper" },
	              _react2.default.createElement(
	                "div",
	                { className: "panel1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4", style: { textAlign: "center" } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "product__img" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "slider__content" },
	                        _react2.default.createElement(
	                          _reactSlick2.default,
	                          settings2,
	                          content.imgUrls.map(function (item, i) {
	                            return _react2.default.createElement(
	                              "div",
	                              { key: i, className: "slider__img" },
	                              _react2.default.createElement("img", {
	                                src: item,
	                                alt: content.detailName,
	                                className: "img img-responsive"
	                              })
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-8" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "h2",
	                        { className: "product__name" },
	                        content.detailName
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "product__nameHindi" },
	                        content.hindiName !== "" ? "( " + content.hindiName + " )" : null
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "sub__heading" },
	                        _react2.default.createElement(
	                          "span",
	                          null,
	                          "Description"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "product__desc" },
	                        content.desc
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "text-grey" },
	                          "Price"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "mrp" },
	                          _react2.default.createElement("i", { className: "fa fa-inr", "aria-hidden": "true" }),
	                          " ",
	                          content.mrp
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "text-grey" },
	                          "Weight"
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "mrp" },
	                          content.netWeight
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _RestrictedStateWiseComponent2.default,
	                      { regionName: region },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-xs-5" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "input-group qty" },
	                            _react2.default.createElement(
	                              "span",
	                              { className: "input-group-btn" },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  onClick: function onClick() {
	                                    return _this4.handleQuantity("sub");
	                                  },
	                                  type: "button",
	                                  className: "quantity-left-minus btn btn-default btn-number",
	                                  "data-type": "minus",
	                                  "data-field": ""
	                                },
	                                _react2.default.createElement("span", { className: "glyphicon glyphicon-minus" })
	                              )
	                            ),
	                            _react2.default.createElement("input", {
	                              readOnly: true,
	                              type: "text",
	                              id: "quantity",
	                              name: "quantity",
	                              className: "form-control input-number",
	                              value: qty || 1,
	                              min: "1",
	                              max: "100"
	                            }),
	                            _react2.default.createElement(
	                              "span",
	                              { className: "input-group-btn" },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  onClick: function onClick() {
	                                    return _this4.handleQuantity("add");
	                                  },
	                                  type: "button",
	                                  className: "quantity-right-plus btn btn-default btn-number",
	                                  "data-type": "plus",
	                                  "data-field": ""
	                                },
	                                _react2.default.createElement("span", { className: "glyphicon glyphicon-plus" })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-xs-7" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "product__Add_to_cart" },
	                            qty > 0 && added ? _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              null,
	                              "Added"
	                            ) : _react2.default.createElement(
	                              _reactBootstrap.Button,
	                              {
	                                onClick: function onClick() {
	                                  return _this4.addToCart(content);
	                                }
	                              },
	                              "Add To Cart"
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "sub__heading" },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        "Ingredients"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "product__desc" },
	                      content.ingredients.map(function (item, i) {
	                        return _react2.default.createElement(
	                          "ul",
	                          { key: i },
	                          _react2.default.createElement(
	                            "li",
	                            null,
	                            item
	                          )
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "product__reci" },
	                      content.recipesId.length ? _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                          _reactBootstrap.Button,
	                          {
	                            onClick: this.onChangeRecipe,
	                            className: "recipe__btn"
	                          },
	                          "Recipes",
	                          " ",
	                          _react2.default.createElement("i", {
	                            className: "fa fa-chevron-" + (showDropdown ? "up" : "down")
	                          })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          {
	                            className: "reci__dropdown",
	                            style: showDropdown ? { display: "block" } : { display: "none" }
	                          },
	                          content.recipesId.length ? content.recipesId.map(function (id) {
	                            if (_productListConstant.recipes[id].isActive) {
	                              return _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                {
	                                  to: "/recipes/" + _productListConstant.recipes[id].title.replace(/ /g, ""),
	                                  key: id
	                                },
	                                _react2.default.createElement(
	                                  "span",
	                                  { className: "reci__title" },
	                                  _productListConstant.recipes[id].title
	                                )
	                              );
	                            } else return null;
	                          }) : _react2.default.createElement(
	                            "div",
	                            { className: "no_recipe" },
	                            "No Recipe found from this Ingredients"
	                          )
	                        )
	                      ) : null
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "panel2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "slider__content" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "desktop" },
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        settingsForDesktop,
	                        sliderList.map(function (item) {
	                          return _react2.default.createElement(
	                            "a",
	                            {
	                              key: item.title,
	                              href: "/products/Detail?" + item.type + "&" + item.urlName.replace(/ /g, "-")
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { key: item.title },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "slider__img" },
	                                _react2.default.createElement("img", {
	                                  src: item.imgSrc,
	                                  alt: item.title,
	                                  className: "img img-responsive"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "slider__title product__below__title" },
	                                item.productName
	                              )
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "mobile" },
	                      _react2.default.createElement(
	                        _reactSlick2.default,
	                        settingsPanel2,
	                        sliderList.map(function (item) {
	                          return _react2.default.createElement(
	                            "a",
	                            {
	                              key: item.title,
	                              href: "/products/Detail?" + item.type + "&" + item.urlName.replace(/ /g, "-")
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { key: item.title },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "slider__img" },
	                                _react2.default.createElement("img", {
	                                  src: item.imgSrc,
	                                  alt: item.title,
	                                  className: "img img-responsive"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "div",
	                                { className: "slider__title" },
	                                item.productName
	                              )
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ) : _react2.default.createElement(
	        "div",
	        {
	          style: {
	            height: "80vh",
	            width: "20%",
	            margin: "20vh auto",
	            textAlign: "center"
	          }
	        },
	        _react2.default.createElement("i", { className: "fa fa-spin fa-spinner" })
	      )
	    );
	  };
	
	  return DetailView;
	}(_react2.default.Component);
	
	DetailView.propTypes = {
	  header1: _propTypes2.default.string,
	  header2: _propTypes2.default.string,
	  region: _propTypes2.default.string,
	  contentPromise: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	
	var mapDispatchToPropsView = function mapDispatchToPropsView(dispatch) {
	  return {
	    setToCart: function setToCart(bucket) {
	      return dispatch({ type: "SET_TO_CART", addToCartList: bucket });
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  // const { params } = ownProps
	  var location = ownProps.location;
	
	  var searchString = "";
	  // console.log(window.location)
	  searchString = (location.search.split("?")[1] || "").split("&");
	  // console.log(location.search.split("/"))
	  var type = searchString[0] || null;
	  var title = searchString[1] || null;
	  // console.log("type", type, title)
	  var contentData = {};
	  var contentPromise = new Promise(function (resolve, reject) {
	    var content = {};
	    if (type === "Spices" && title) {
	      _productListConstant.SpiceDetails.forEach(function (item) {
	        if (title === item.urlName.replace(/ /g, "-")) {
	          content = state.addToCartList.products[item.id] || item;
	        }
	      });
	    } else if (type === "Dhoop" && title) {
	      _productListConstant.DhoopDetails.forEach(function (item) {
	        if (title === item.urlName.replace(/ /g, "-")) {
	          content = state.addToCartList.products[item.id] || item;
	        }
	      });
	    } else if (type === "Misc" && title) {
	      _productListConstant.Misc.forEach(function (item) {
	        if (title === item.urlName.replace(/ /g, "-")) {
	          content = state.addToCartList.products[item.id] || item;
	        }
	      });
	    } else {
	      content = {};
	    }
	    return resolve(content);
	  });
	  // content1.then(item => console.log(item))
	  // console.log("content", contentData)
	  return _extends({}, ownProps, {
	    contentPromise: contentPromise,
	    header1: type,
	    header2: title,
	    isAddToCartChange: state.addToCartList.isAddToCartChange,
	    region: state.ipData.region || "delhi"
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToPropsView)(DetailView);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-detail-index-js-526e6431fd73003810d6.js